import config from './Config';
if (window.INITIAL_CONFIG) {
    config.initialize(window.INITIAL_CONFIG);
}
